// extracted by mini-css-extract-plugin
export default {"admin-header":"AdminHeader_admin-header__r2u8I","admin-header__logo":"AdminHeader_admin-header__logo__Rrgb8","admin-header__user":"AdminHeader_admin-header__user__ddtul"};